// extracted by mini-css-extract-plugin
module.exports = {"list":"Accordion_list__VhNZB","item":"Accordion_item__M3ubr","content":"Accordion_content__BuBzA","title":"Accordion_title__uQb1c","chevron":"Accordion_chevron__G3dOC"};